<template>
  <v-form v-model="valid" :lazy-validation="lazy" ref="form" v-show="isMounted" autocomplete="off">
    <v-container>
      <!--
      <v-card-title class="font-weight-bold">登録情報</v-card-title>
      -->
      <!-- :rules="nameRules" -->
      <v-text-field
        v-model="InputData.Title"
        label="タイトル(*)"
        :counter="50"
        :rules="TitleRules"
        required
      ></v-text-field>

      <v-menu
        v-model="IsDatePickerDisplay"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <!-- @blur="InputData.TargetDate = parseDate(InputData.TargetDate)" -->

        <template v-slot:activator="{ on }">
          <!-- 外す :rules="RequiredRules" required -->
          <v-text-field v-model="InputData.TargetDate" label="対象日" v-on="on"></v-text-field>
        </template>
        <v-date-picker
          v-model="InputData.TargetDate"
          no-title
          @input="IsDatePickerDisplay = false"
          locale="jp-ja"
          :day-format="date => new Date(date).getDate()"
        ></v-date-picker>
      </v-menu>

      <!-- <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="InputData.NotificationCount"
            label="通知件数"
            :rules="NotificationCountRules"
            v-on="on"
          ></v-text-field>
        </template>
        <span>使用ユーザが通知機能を使用した場合に、〇番目に前に通知<br/>例：ユーザがNO:3 のプログラムを通知設定。こちらの設定が1の場合 NO:2のプログラム（ひとつ前）で通知<br/>※空欄で未使用</span>
      </v-tooltip>-->

      <v-row>
        <v-col cols="6">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-switch
                v-model="InputData.MultipleFlag"
                value
                input-value="true"
                :label="MultipleString"
                v-on="on"
              ></v-switch>
            </template>
            <span>プログラムを複数選択可能とする場合はONにしてください</span>
          </v-tooltip>
        </v-col>

        <v-col cols="6">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-switch
                v-model="InputData.TitleOneFlag"
                value
                input-value="true"
                :label="TitleOneString"
                :disabled="!InputData.MultipleFlag"
                v-on="on"
              ></v-switch>
            </template>
            <span>タイトル内は一つの選択にする場合はONにしてください</span>
          </v-tooltip>
        </v-col>   


        <v-col cols="6">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-switch
                v-model="InputData.ProgramNoDisplayFlag"
                value
                input-value="true"
                :label="ProgramNoDisplayString"
                v-on="on"
              ></v-switch>
            </template>
            <span>プログラムNoを表示する場合にはONにしてください</span>
          </v-tooltip>
        </v-col>   

        <!-- <v-col cols="6">
          

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-switch v-model="InputData.LoopFlag" value input-value="true"  :label="LoopString" v-on="on"></v-switch>
            </template>
            <span>最後まで行くと、最初に戻る場合の運用にはONにしてください</span>
          </v-tooltip>          

        </v-col>-->
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="InputData.TwitterUrl" v-on="on" label="TwitterUrl"></v-text-field>
            </template>
            <span>Twitterのツイート時のURL</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="InputData.TwitterHashtag" v-on="on" label="TwitterHashtag"></v-text-field>
            </template>
            <span>Twitterのハッシュタグ</span>
          </v-tooltip>
        </v-col>

        <v-col cols="4">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="InputData.FacebookID" v-on="on" label="FacebookID"></v-text-field>
            </template>
            <span>https://www.facebook.com/◆◆◆◆←こちらの部分になります</span>
          </v-tooltip>
        </v-col>

      </v-row>


      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width:50px;">No</th>
              <th class="pl-1 pr-1">タイトル</th>
              <th class="pl-1 pr-1">プログラム名</th>
              <th class="pl-1 pr-1">備考</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item,index) in InputData.Programs"
              :key="index"
              v-bind:class="{ 'light-blue lighten-5' : (item.TitleFlag || false)==true}"
            >
              <td class="pl-0 pr-0" style="text-align:center;">{{ item.ProgramID }}</td>
              <td class="pl-0 pr-0" style="text-align:center;">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-switch v-model="item.TitleFlag" value input-value="true" v-on="on"></v-switch>
                  </template>
                  <span>行をタイトルとして使用する場合ONにしてください</span>
                </v-tooltip>
              </td>
              <td class="pl-1 pr-1">
                <v-text-field v-model="item.ProgramName" :counter="50" :rules="Max50lengthRules"></v-text-field>
              </td>
              <td class="pl-1 pr-1">
                <v-text-field
                  v-model="item.ProgramRemarks"
                  :counter="150"
                  :rules="Max150lengthRules"
                ></v-text-field>
              </td>
              <td class="pl-0 pr-0" style="text-align:center;">
                <i
                  role="button"
                  class="v-icon notranslate v-icon--link material-icons theme--light"
                  @click="addDetailData(item.ProgramID);"
                >add</i>
                &nbsp;
                <i
                  role="button"
                  class="v-icon notranslate v-icon--link material-icons theme--light"
                  @click="moveData(item.ProgramID,true);"
                >expand_less</i>
                <i
                  role="button"
                  class="v-icon notranslate v-icon--link material-icons theme--light"
                  @click="moveData(item.ProgramID,false);"
                >expand_more</i>
                &nbsp;
                <i
                  role="button"
                  class="v-icon notranslate v-icon--link material-icons theme--light"
                  @click="deleteDetailData(item.ProgramID)"
                >delete</i>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-container>
        <v-btn class="primary" :disabled="!valid" @click="submit()">登録</v-btn>&nbsp;
        <v-btn class="warning" :disabled="!isDelete" @click="deleteData()">削除</v-btn>
      </v-container>
    </v-container>

    <v-snackbar
      v-model="isSnackbar"
      :color="SnackbarColor"
      :timeout="SnackbarTimeOut"
      top="true"
    >{{SnackbarMessage}}</v-snackbar>
  </v-form>
</template>



<script>
//import firebase from "firebase/app";
import project from "../project.js";
const API_URL = "/api/inputprogram/";

export default {
  name: "inputprogram",
  mounted: async function() {
    let val = project.GetUrlVars();

    await this.clear(val["PrimaryKey"]);
    this.isMounted = true;
  },
  data: function() {
    return {
      isMounted: false,
      isSnackbar: false,
      SnackbarColor: "success",
      SnackbarMessage: "",
      SnackbarTimeOut: 2000,

      IsDatePickerDisplay: false,
      valid: false,
      lazy: false,

      TitleRules: [
        v => !!v || "必須項目です",
        v => (v && v.length <= 50) || "50文字以内で入力"
      ],

      NotificationCountRules: [
        v =>
          v == null ||
          v.length == 0 ||
          /^[0-9]*$/.test(v) ||
          "数値で入力してください"
      ],

      RequiredRules: [v => !!v || "必須項目です"],

      Max50lengthRules: [
        v =>
          v == null || (v.length >= 0 && v.length <= 50) || "50文字以内で入力"
      ],

      Max150lengthRules: [
        v =>
          v == null || (v.length >= 0 && v.length <= 150) || "150文字以内で入力"
      ],

      InputData: {
        PrimaryKey: null, //pk(server)
        ShortKey: null, //通知する際の省略キー(基本pkの左から5桁)
        AppendDate: null, //追加した日(server)
        Title: null,
        TargetDate: null,
        MultipleFlag: false,    //複数選択
        TitleOneFlag: false,    //タイトルの中で一つだけ選択とする
        ProgramNoDisplayFlag: true,    //タイトルNoを表示
        NotificationCount: null,  //通知する場合〇番前の時に追加するか（現在未使用）
        LoopFlag: false,
        TwitterHashtag: null,
        TwitterUrl: null,
        FacebookID: null,
        Programs: []
        //ProgramID 一意の連番
        //ProgramName プログラム名
        //ProgramRemarks プログラム備考
        //ProgramTitleID タイトルごとの連番
        //ProgramGroupID グループ毎の番号
      }
    };
  },
  methods: {
    clear: async function(key) {
      const MAX_DUMMY_DATA = 2;

      //もしnew edit判定が必要であれば this.getData(key);の後の this.InputData.PrimaryKey で判定すること
      //背景：削除時のリロード時 querystringが変わらないため
      if (key != null) {
        project.SetLoading(true);
        await this.getData(key);
        project.SetLoading(false);
      }
      //{} 判定
      if (key == null || this.InputData.PrimaryKey == null) {
        this.InputData.PrimaryKey = null;
        this.InputData.Programs = [];

        //新規
        // if (
        //   this.InputData.Programs == null ||
        //   this.InputData.Programs.length < MAX_DUMMY_DATA
        // ) {
        let start = (this.InputData.Programs.length || 1) - 1;

        for (let i = start; i < MAX_DUMMY_DATA; i++) {
          this.InputData.Programs.push({ ProgramID: i + 1 });
        }
      }
    },

    getData: async function(key) {
      await project
        .PostApi(API_URL + "getData", { PrimaryKey: key }, true)
        .then(data => {
          //一度でもセットすると勝手にバリデーションが走るので、処理追加
          if (project.IsEmpty(data) == false) {
            this.InputData = data;
          }
        })
        .catch(e => {
          alert(e.message);
        });
    },
    submit: async function() {
      // let v = this.$refs.form.validate();
      // alert(v);
      // if (v) {
      //   //this.snackbar = true
      // }

      //タイトルごとに連番を付与
      //ProgramTitleID

      let data = JSON.parse(JSON.stringify(this.InputData));

      //複数選択しない場合は、タイトル内の選択は無視する
      if (data.MultipleFlag == false ){
        data.TitleOneFlag = false;
      }

      let programData = [];
      let programGroupID = 0;
      let programTitleID = 0;
      let ProgramIDCount = 0;
      for (let i = 0; i < data.Programs.length || 0; i++) {
        if (
          data.Programs[i]["ProgramName"] != null &&
          data.Programs[i]["ProgramName"].toString() != ""
        ) {
          if ((data.Programs[i]["TitleFlag"] || false) == true) {
            programTitleID = 0;
            programGroupID++;
            data.Programs[i]["ProgramTitleID"] = null;
          } else {
            data.Programs[i]["ProgramGroupID"] = programGroupID;
            programTitleID++;
            data.Programs[i]["ProgramTitleID"] = programTitleID;
          }
          ProgramIDCount++;
          data.Programs[i]["ProgramID"] = ProgramIDCount;
          programData.push(data.Programs[i]);
        }
      }

      if (programData.length == 0) {
        alert("プログラムを1件以上登録してください。");
        return;
      }

      data.Programs = programData;

      project.SetLoading(true); //２度押し防止用くるくる（開始）

      let isOK = false;
      await project
        .PostApi(API_URL + "submit", data, true)
        .then(data => {
          if (project.IsEmpty(data) == false) {
            isOK = true;
          }
        })
        .catch(e => {
          alert(e.message);
          return;
        });

      project.SetLoading(false); //２度押し防止用くるくる（終了）

      if (isOK == true) {
        this.isSnackbar = true;
        this.SnackbarMessage = "登録しました";

        setTimeout(() => {
          this.$router.push({ name: "inputprogramlist" });
        }, this.SnackbarTimeOut);
      }
    },
    deleteData: async function() {
      if (confirm("削除します。よろしいですか？\n(課金データも削除されますのでご注意下さい)") == false) {
        return;
      }

      project.SetLoading(true); //２度押し防止用くるくる（開始）

      let isOK = false;
      await project
        .PostApi(API_URL + "deleteData", this.InputData, true)
        .then(data => {
          if (project.IsEmpty(data) == true) {
            //自分のページを再読み込み
            //this.$router.go({path: this.$router.currentRoute.path,force: true});
            isOK = true;
          }
        })
        .catch(e => {
          alert(e.message);
          return;
        });

      project.SetLoading(false); //２度押し防止用くるくる（終了）

      if (isOK == true) {
        this.isSnackbar = true;
        this.SnackbarMessage = "削除しました";

        setTimeout(() => {
          this.$router.push({ name: "inputprogramlist" });
        }, this.SnackbarTimeOut);
      }
    },

    addDetailData: function(programID) {
      for (let i in this.InputData.Programs) {
        if (this.InputData.Programs[i].ProgramID == programID) {
          this.InputData.Programs.splice(i + 1, 0, {});
          break;
        }
      }

      //ProgramIDを振り直し
      for (let i in this.InputData.Programs) {
        this.InputData.Programs[i].ProgramID = +i + 1;
      }
    },
    deleteDetailData: function(programID) {
      //alert(programID);
      if ((this.InputData.Programs.length || 0) <= 1) {
        alert("データは削除できません");
        return;
      }

      for (let i in this.InputData.Programs) {
        if (this.InputData.Programs[i].ProgramID == programID) {
          this.InputData.Programs.splice(i, 1);
          break;
        }
      }

      //ProgramIDを振り直し
      for (let i in this.InputData.Programs) {
        this.InputData.Programs[i].ProgramID = +i + 1;
      }
    },

    moveData: function(programID, moveFlag) {
      // //alert(programID);
      // if ((this.InputData.Programs.length || 0) <= 1) {
      //   alert("データは削除できません");
      //   return;
      // }
      //alert(programID);

      for (let i in this.InputData.Programs) {
        if (this.InputData.Programs[i].ProgramID == programID) {
          //this.InputData.Programs.splice(i, 1);
          let index = +i;

          if (moveFlag == true) {
            index = index - 1;
          }

          if (
            this.InputData.Programs[index + 1] != null &&
            this.InputData.Programs[index] != null
          ) {
            this.InputData.Programs.splice(
              index,
              2,
              this.InputData.Programs[index + 1],
              this.InputData.Programs[index]
            );
          }
          break;
        }
      }

      //ProgramIDを振り直し
      for (let i in this.InputData.Programs) {
        this.InputData.Programs[i].ProgramID = +i + 1;
      }
    }
  },
  computed: {
    isDelete: function() {
      if ((this.InputData.PrimaryKey || "").length == 0) {
        return false;
      } else {
        return true;
      }
    },
    MultipleString: function() {
      if ((this.InputData.MultipleFlag || false) == false) {
        return "複数選択を行わない";
      } else {
        return "複数選択を行う";
      }
    },
    TitleOneString: function() {
      if ((this.InputData.TitleOneFlag || false) == false) {
        return "タイトル内は複数選択できる";
      } else {
        return "タイトル内の選択は1つ";
      }
    },
    ProgramNoDisplayString: function() {
      if ((this.InputData.ProgramNoDisplayFlag || false) == false) {
        return "プログラムNoを自動表示しない";
      } else {
        return "プログラムNoを自動表示する";
      }
    },
    LoopString: function() {
      if ((this.InputData.LoopFlag || false) == false) {
        return "ループ使用しない";
      } else {
        return "ループ使用する";
      }
    }
  }
};
</script>